import { hasStringKey } from "@/utils/misc";
import { getOptions } from "./utils";
import Label from "@ingka/label";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: Record<string, string>;
  disabled: boolean;
};

const ProductionOrderedBy = ({ options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("productionOrderedBy", activeAsset.id!);
  const isUpdating =
    isMetadataUpdating(activeAsset.id!, "producedBy") ||
    isMetadataUpdating(activeAsset.id!, "productionOrderedBy");

  const selectedValue = activeAsset.productionOrderedBy || "";

  return (
    <>
      <Label
        htmlFor="productionOrderedBy"
        label={
          <LabelWithToolTip
            labelText="Production ordered by"
            toolTipText="If the content is created by an external agency we need to know from where the order came. Please select if it was ordered by a specific market."
          />
        }
      />
      <CustomSelect
        id="productionOrderedBy"
        disabled={disabled || isUpdating}
        options={getOptions(options)}
        errorMessage={error?.message}
        value={{ label: options[selectedValue], value: selectedValue }}
        onChange={(option) => {
          if (hasStringKey("value", option)) {
            updateMetadata({
              productionOrderedBy: option.value,
            });
          }
        }}
      />
    </>
  );
};

export default ProductionOrderedBy;
